<template>
  <div v-if="!stacked">
    <b-row>
      <b-col>
        <b-form-group label="x">
          <b-form-input type="number" v-model="x" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="y">
          <b-form-input type="number" v-model="y" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="w">
          <b-form-input type="number" v-model="w" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="h">
          <b-form-input type="number" v-model="h" />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
  <div v-else>
    <b-form-group label="x" label-cols-sm="1" class="mb-1">
      <b-form-input type="number" v-model="x" />
    </b-form-group>
    <b-form-group label="y" label-cols-sm="1" class="mb-1">
      <b-form-input type="number" v-model="y" />
    </b-form-group>
    <b-form-group label="w" label-cols-sm="1" class="mb-1">
      <b-form-input type="number" v-model="w" />
    </b-form-group>
    <b-form-group label="h" label-cols-sm="1" class="mb-1">
      <b-form-input type="number" v-model="h" />
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'CoordsEditor',
  props: {
    value: {
      type: Object,
      required: true
    },
    stacked: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    x() {
      this.$emit('change', this.coords)
    },
    y() {
      this.$emit('change', this.coords)
    },
    w() {
      this.$emit('change', this.coords)
    },
    h() {
      this.$emit('change', this.coords)
    },
    value(newValue) {
      this.x = newValue.x
      this.y = newValue.y
      this.h = newValue.h
      this.w = newValue.w
    }
  },
  computed: {
    coords() {
      return {
        x: Number(this.x),
        y: Number(this.y),
        w: Number(this.w),
        h: Number(this.h)
      }
    }
  },
  model: {
    event: 'change'
  },
  data() {
    return {
      ...this.value
    }
  }
}
</script>

<style scoped></style>
